// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrums_container__l_3gC","separator":"Breadcrums_separator__cWpId","noLinkItem":"Breadcrums_noLinkItem__rqpx0"};